import { Components, Theme } from '@mui/material/styles';
import { colors } from 'styles/colors';

export const muiXDatePickerOverride: Components<Omit<Theme, 'components'>>['MuiDatePicker'] = {
  defaultProps: {
    sx: {
      fontSize: '0.875rem',
      '& .MuiInputBase-input': {
        fontSize: '0.875rem',
        color: colors.text[80]
      },
      '& .MuiInputLabel-root': {
        fontSize: '0.875rem',
        color: colors.text[80]
      }
    }
  }
};
